import { ViewConfig } from '@helo/cms'

import { WidgetRenderer2 } from '../widgets/WidgetRenderer/WidgetRenderer2'
import { ViewDocumentTitle } from './ViewDocumentTitle'

export interface ScreenPageProps {
  viewConfig: ViewConfig
}

export const ScreenPage = ({ viewConfig }: ScreenPageProps) => {
  return (
    <>
      <ViewDocumentTitle viewConfig={viewConfig} />
      {viewConfig.widgets.map((widget, i) => (
        <WidgetRenderer2
          widgetConfig={widget}
          key={widget.state.widgetId ?? widget.type + i}
        />
      ))}
    </>
  )
}
